// Shared source of truth for space listings.
// Used by featured-spaces (cards) and spaces.$spaceId (dynamic head metadata + Product JSON-LD)
// so structured data always matches the actual page content.
import s1 from "@/assets/space-1.webp";
import s2 from "@/assets/space-2.webp";
import s3 from "@/assets/space-3.webp";
import s4 from "@/assets/space-4.webp";
import s5 from "@/assets/space-5.webp";

export interface SpaceInfo {
  id: string;
  img: string;
  title: string;
  city: string;
  price: number; // SAR per hour
  rating: number;
  reviews: number;
  tag?: string;
  subscription: boolean;
  description: string;
}

export const SPACES: SpaceInfo[] = [
  {
    id: "1",
    img: s1,
    title: "Industrial loft with brick walls",
    city: "Riyadh",
    price: 64,
    rating: 4.92,
    reviews: 128,
    tag: "Popular",
    subscription: true,
    description:
      "Book this industrial loft by the hour. Add catering, photography, and sound equipment in one seamless checkout.",
  },
  {
    id: "2",
    img: s2,
    title: "Pastel podcast studio",
    city: "Jeddah",
    price: 38,
    rating: 4.87,
    reviews: 94,
    subscription: false,
    description:
      "A pastel-toned podcast studio in Jeddah with pro audio gear. Hourly booking with optional add-ons.",
  },
  {
    id: "3",
    img: s3,
    title: "Skyline rooftop terrace",
    city: "Dammam",
    price: 95,
    rating: 5.0,
    reviews: 41,
    tag: "New",
    subscription: true,
    description:
      "Skyline rooftop terrace in Dammam for events and gatherings. Hourly rental with catering and equipment add-ons.",
  },
  {
    id: "4",
    img: s4,
    title: "Velvet lounge meeting room",
    city: "Mecca",
    price: 52,
    rating: 4.95,
    reviews: 212,
    subscription: false,
    description:
      "Velvet lounge meeting room in Mecca, bookable by the hour with catering and AV add-ons.",
  },
  {
    id: "5",
    img: s5,
    title: "Minimal gallery space",
    city: "Khobar",
    price: 78,
    rating: 4.89,
    reviews: 67,
    subscription: true,
    description:
      "Minimal gallery space in Khobar for exhibitions and pop-ups. Hourly booking with optional services.",
  },
];

export function getSpace(id: string): SpaceInfo {
  return SPACES.find((s) => s.id === id) ?? SPACES[0];
}
